import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UploadFileService {

    constructor(private http: HttpClient) { }

    upload(file: File): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();

        formData.append('file', file);

        const req = new HttpRequest('POST', environment.apiUrl + '/loan/api/user-branch/upload', formData, {
            reportProgress: true,
            responseType: 'json'
        });

        return this.http.request(req);

        /* return this.http
         .post<any>(environment.apiUrl+'/loan/api/user-branch/upload',formData)
         .pipe(
           map((res : any) => {
             return res;
           })
         );*/
    }



    getFiles(): Observable<any> {
        return this.http.get(environment.apiUrl + '/loan/api/user-branch/files');
    }
}
